import { mock_enterprise } from '@/constant/mock-enterprise';
import {
  IEnterpriseProfileStructureJSON,
  TEnterpriseTabSection,
} from '@/interfaces/enterprise-profile/enterprise.interface';
import { TStructure } from './admin/context/AdminEnterpriseDataProvider';

const mock = mock_enterprise.structure;

export const updateToLatestStructure = (structure: TStructure): TStructure => {
  const allStructureTabKey = new Set(structure.map((item) => item.tabKey));
  const updatedStructure: TStructure = [];

  for (const currentItem of structure) {
    const allTabsSectionsKeys = new Set(
      structure
        .filter((item2) => item2.tabKey === currentItem.tabKey)
        .flatMap((item2) =>
          item2.sections.flatMap((section) => section.sectionKey)
        )
    );

    const missingSections = mock
      .filter((i) => i.tabKey === currentItem.tabKey)
      .flatMap((i: TStructure[0] & { sections: Array<any> }) =>
        i.sections.filter(
          (section: any) => !allTabsSectionsKeys.has(section.sectionKey)
        )
      );

    const updatedSections = currentItem.sections.map((currentSection) => {
      const allFieldsOfStructure = new Set(
        structure
          .filter((item2) => item2.tabKey === currentItem.tabKey)
          .flatMap((item2) =>
            (item2.sections as any)
              .filter(
                (section2: TEnterpriseTabSection[0]) =>
                  section2.sectionKey === currentSection.sectionKey
              )
              .flatMap((section2: TEnterpriseTabSection[0]) =>
                section2.elements
                  ? Object.keys(section2.elements)
                  : section2.elements
              )
          )
      );

      const fieldsToUpdate = mock
        .filter((i) => i.tabKey === currentItem.tabKey)
        .flatMap((i: TStructure[0] & { sections: Array<any> }) =>
          i.sections
            .filter(
              (section2) => section2.sectionKey === currentSection.sectionKey
            )
            .map((section2) => {
              if (!section2.elements) return;

              const missingKeys = Object.keys(section2.elements)
                .filter((key) => !allFieldsOfStructure.has(key))
                .reduce((acc: any, cur) => {
                  acc[cur] = section2.elements[cur];
                  return acc;
                }, {});

              const redundantKeys = Array.from(allFieldsOfStructure).filter(
                (key) => !Object.keys(section2.elements).includes(key!)
              );

              return {
                missingKeys,
                redundantKeys,
              };
            })
            .filter((i) => i && Object.keys(i.missingKeys).length > 0)
        );

      fieldsToUpdate[0]?.redundantKeys?.forEach((key) => {
        if (currentSection.elements) {
          delete (currentSection.elements as Record<string, any>)[key];
        }
      });

      return {
        ...currentSection,
        elements: {
          ...currentSection.elements,
          ...(Object.keys(fieldsToUpdate[0]?.missingKeys || {}).length > 0
            ? Object.keys(fieldsToUpdate[0]?.missingKeys).reduce(
                (acc: any, cur) => {
                  acc[cur] = fieldsToUpdate[0]?.missingKeys[cur];
                  return acc;
                },
                {}
              )
            : {}),
        },
      };
    });

    updatedStructure.push({
      ...currentItem,
      sections: [
        ...updatedSections,
        ...(missingSections.length > 0 ? missingSections : []),
      ] as IEnterpriseProfileStructureJSON['structure'][0]['sections'],
    });
  }

  const lackTabs = mock.filter((i) => !allStructureTabKey.has(i.tabKey));

  return [...updatedStructure, ...(lackTabs.length > 0 ? lackTabs : [])];
};
